export interface TrackedJob {
  name: string;
  functionName: string;
  label: string;
  countLabel: string;
  destructive?: boolean;
  destructiveWarning?: string;
}

export interface CronRow {
  jobid: number;
  jobname: string;
  schedule: string | null;
  active: boolean | null;
  status: string | null;
  return_message: string | null;
  start_time: string | null;
  end_time: string | null;
}

export interface RunLogRow {
  function_name: string;
  affected_count: number;
  success: boolean;
  ran_at: string;
}

export interface FailureInfo {
  message: string;
  raw: unknown;
}

export const TRACKED_JOBS: TrackedJob[] = [
  { name: "check-license-expiry-nightly", functionName: "check-license-expiry", label: "License expiry check", countLabel: "notified" },
  {
    name: "cleanup-stray-credentials-nightly",
    functionName: "cleanup-stray-credentials",
    label: "Stray credential cleanup",
    countLabel: "deleted",
    destructive: true,
    destructiveWarning:
      "This will permanently delete provider credentials and contractor tax info that no longer have a matching auth user. Deleted records cannot be recovered.",
  },
  { name: "check-consultation-reminders-daily", functionName: "check-consultation-reminders", label: "Consultation reminders", countLabel: "sent" },
  {
    name: "prune-maintenance-run-log-daily",
    functionName: "prune-maintenance-run-log",
    label: "Prune old run log entries",
    countLabel: "pruned",
  },
];
